import type { CrmIntegrationConversation } from '../types/crm-integration-chat.types'

/** На табе «Все» недоступные чаты — в конце, порядок внутри групп сохраняется (серверный). */
export const sortIntegrationChatsInaccessibleLast = (
  chats: CrmIntegrationConversation[],
  integrationAccessibleById: Record<number, boolean>,
): CrmIntegrationConversation[] => {
  if (chats.length <= 1) {
    return chats
  }

  const accessible: CrmIntegrationConversation[] = []
  const inaccessible: CrmIntegrationConversation[] = []

  for (const item of chats) {
    if (integrationAccessibleById[item.integration_id] ?? true) {
      accessible.push(item)
    } else {
      inaccessible.push(item)
    }
  }

  if (inaccessible.length === 0 || accessible.length === 0) {
    return chats
  }

  return [...accessible, ...inaccessible]
}
